import { Zap } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function MenuBarLogo() {
  const navigate = useNavigate()
  return (
    <div
      onClick={() => navigate('/')}
      style={{ display: 'flex', alignItems: 'center', gap: '6px', marginRight: '16px', cursor: 'pointer' }}
    >
      <Zap size={13} color="#6366f1" />
      <span style={{
        fontWeight: 800,
        fontSize: '13px',
        background: 'linear-gradient(135deg,#6366f1,#ec4899)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}>
        RunAI OS
      </span>
    </div>
  )
}